// extracted by mini-css-extract-plugin
export default {"container":"LogsPage_container__tHd9J","search-container":"LogsPage_search-container__L7Sjn"};